module.exports = __webpack_public_path__ + "src/assets/media/girl.jpg";